import { createAction } from 'typesafe-actions'

export const switchPriceView = createAction('CMD / PriceView / switch')<string>()
